// extracted by mini-css-extract-plugin
export default {"navlink":"Navigation_navlink__w5YI7","navlist":"Navigation_navlist__945kT"};